import {$api} from "./index";

export const createNewSetting = async (parameter) => {
    const {data} = await $api.post('api/setting', parameter)
    return data
}

export const fetchSetting = async () => {
    const {data} = await $api.get('api/setting')
    return data
}

export const updateSetting = async (parameter) => {
    const {data} = await $api.put('api/setting', parameter)
    return data
}
